import { Add, Remove } from "@mui/icons-material";
import React from "react";
import { colors } from "../../theme/theme";

const CustomAccordion = ({ title, content, isOpen, toggle }) => (
  <div className="mx-5">
    <div
      onClick={toggle}
      className="flex justify-between items-center py-2 cursor-pointer"
    >
      <span
        style={{
          fontSize: "16px",
          color: colors.textColor3,
          fontFamily: "Poppins-Medium",
        }}
      >
        {title}
      </span>
      <div
        className={`flex justify-center items-center p-2 bg-[#BBDEA5] rounded-lg transition-transform duration-300 ${
          isOpen ? "rotate-180" : "rotate-0"
        }`}
      >
        {/* Plus/Minus icon */}
        {isOpen ? (
          <Remove sx={{ fontSize: "20px", color: "#000" }} />
        ) : (
          <Add sx={{ fontSize: "20px", color: "#000" }} />
        )}
      </div>
    </div>

    {/* Accordion Content */}
    <div
      className={`overflow-hidden transition-all duration-500 ease-in-out ${
        isOpen ? "max-h-screen" : "max-h-0"
      }`}
    >
      <div className="px-4 py-2 text-md">{content || "N/A"}</div>
    </div>
  </div>
);

export default CustomAccordion;
